import restClient from "../restClient";

export const normalizeInventoryWebsiteStatusKeys = (statuses) =>
  Array.from(
    new Set(
      (Array.isArray(statuses) ? statuses : String(statuses || "").split(","))
        .map((statusKey) => String(statusKey || "").trim().toLowerCase())
        .filter(Boolean)
    )
  ).sort();

export const getInventoryWebsites = async ({
  page = 1,
  pageSize = 25,
  search = "",
  status = "all",
  statuses = [],
} = {}) => {
  const token = localStorage.getItem("token");
  const normalizedStatusKeys = normalizeInventoryWebsiteStatusKeys(statuses);
  const response = await restClient.get("inventory-websites", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      page,
      pageSize,
      ...(search ? { search } : {}),
      ...(status && status !== "all" ? { status } : {}),
      ...(normalizedStatusKeys.length
        ? { statuses: normalizedStatusKeys.join(",") }
        : {}),
    },
  });
  return response.data;
};

export const getInventoryWebsite = async (id) => {
  const token = localStorage.getItem("token");
  const response = await restClient.get(`inventory-websites/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const createInventoryWebsite = async (data) => {
  const token = localStorage.getItem("token");
  const response = await restClient.post(
    "inventory-websites",
    { data },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const updateInventoryWebsite = async (id, data, files) => {
  const token = localStorage.getItem("token");

  if (files?.length) {
    const formData = new FormData();
    formData.append("data", JSON.stringify(data || {}));
    // Strapi body middleware looks for the "files" field name
    files.forEach((file) => {
      formData.append("files", file);
    });

    const response = await restClient.put(`inventory-websites/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }

  const response = await restClient.put(
    `inventory-websites/${id}`,
    { data },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const bulkToggleInventoryWebsites = async (ids) => {
  const token = localStorage.getItem("token");
  const response = await restClient.post(
    "inventory-websites/bulk-toggle-active",
    { ids },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};
